module.exports = __webpack_public_path__ + "img/Gummies-40ct.efee1aab.jpg";